import { jsx as _jsx } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { IncognitoType } from '#pplx/frontend/apps/ask/incognito/types.js';
import { useIsIncognito } from '#pplx/frontend/apps/ask/incognito/useIsIncognito.js';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const IncognitoInputHint = React.memo(function IncognitoInputHint({ className }) {
    useIntl();
    const { isIncognito, incognitoType } = useIsIncognito({ reason: 'home-incognito-hint' });
    if (!isIncognito || incognitoType !== IncognitoType.DEFAULT) {
        return null;
    }
    return (_jsx("div", { className: classNames(className ?? 'mt-2', 'flex w-full justify-center text-center'), children: _jsx(TextPrimitive, { variant: "small", color: "light", children: _jsx(FormattedMessage, { defaultMessage: "Sessions you create won't save to your history and expire after 24 hours", description: "Subtitle text on the homepage explaining incognito mode behavior", id: "97663e09c7" }) }) }));
});
//# sourceMappingURL=IncognitoInputHint.js.map